export interface SelectOption {
    value: string;
    label: string;
}

export function buildYearOptions(startYear = 2024, endYear = new Date().getFullYear()): SelectOption[] {
    const years: SelectOption[] = [];

    for (let year = startYear; year <= endYear; year++) {
        years.push({
            value: String(year),
            label: String(year)
        });
    }

    return years;
}

export function buildMonthOptions(includeAll = true): SelectOption[] {
    const months: SelectOption[] = [
        { value: '01', label: 'Enero' },
        { value: '02', label: 'Febrero' },
        { value: '03', label: 'Marzo' },
        { value: '04', label: 'Abril' },
        { value: '05', label: 'Mayo' },
        { value: '06', label: 'Junio' },
        { value: '07', label: 'Julio' },
        { value: '08', label: 'Agosto' },
        { value: '09', label: 'Septiembre' },
        { value: '10', label: 'Octubre' },
        { value: '11', label: 'Noviembre' },
        { value: '12', label: 'Diciembre' }
    ];

    return includeAll
        ? [{ value: 'null', label: 'Todos' }, ...months]
        : months;
}
